<span [id]="ariaLabelId" class="aria-visually-hidden"> {{ ariaLabelText }} </span>